import { render, staticRenderFns } from "./EditContactForm.vue?vue&type=template&id=2eb90262&"
import script from "./EditContactForm.vue?vue&type=script&lang=js&"
export * from "./EditContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports